<div class="surface-default w-full max-w-3xl rounded-xl border border-neutral-5 p-4 pb-8">
  <div class="flex flex-col gap-4">
    <div class="flex w-full sm:items-center">
      <div class="flex w-full items-center gap-4">
        @if (email().context.user; as user) {
          <aura-avatar
            [label]="user.identity.firstName"
            [srcImage]="$safeNavigationMigration(user.identity.avatar?.url)"
            [size]="'l'"
          />
        } @else if (email().context.betaRegistration; as betaRegistration) {
          <aura-avatar [label]="betaRegistration.firstName" [size]="'l'" />
        }

        <div class="flex flex-col">
          <div class="text-xl font-semibold">
            @if (email().context.user; as user) {
              <button
                mat-button
                class="link text-xl font-semibold"
                [matTooltip]="'Utilisateur'"
                [routerLink]="['/users', user._id]"
              >
                {{ user.identity.firstName | titlecase }}
                {{ user.identity.lastName | titlecase }}
              </button>
            } @else if (email().context.userRegistration; as userRegistration) {
              <button
                mat-button
                class="link text-xl font-semibold"
                [matTooltip]="'Inscription'"
                [routerLink]="['/user-registrations', userRegistration._id]"
              >
                {{ userRegistration.identity.firstName | titlecase }}
                {{ userRegistration.identity.lastName | titlecase }}
              </button>
            } @else if (email().context.betaRegistration; as betaRegistration) {
              <button
                mat-button
                class="link text-xl font-semibold"
                [matTooltip]="'Inscription Bêta'"
                [routerLink]="['/beta-registrations', betaRegistration._id]"
              >
                {{ betaRegistration.firstName | titlecase }}
                {{ betaRegistration.lastName | titlecase }}
              </button>
            }
          </div>
          <div>{{ email().to }}</div>
        </div>
      </div>
      <div class="flex w-full justify-end">
        <div [matTooltip]="'Modifié: ' + (email().updatedAt | luxonDate: 'dd/LL/yyyy HH:mm')">
          {{ email().createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}
        </div>
      </div>
    </div>
    <mat-divider />
    <div class="mb-4 flex text-2xl font-bold sm:items-center">
      <div>{{ email().subject }}</div>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="mb-4 flex items-center gap-2 border-b py-2">
    <mat-icon class="text-neutral-11">
      @if (view() === 'text') {
        article
      } @else if (view() === 'html') {
        code
      }
    </mat-icon>
    <h2 class="text-neutral-12 w-full text-lg font-semibold">
      Contenu
      @if (view() === 'text') {
        texte
      } @else if (view() === 'html') {
        HTML
      }
    </h2>
    <div class="flex items-center gap-2">
      <button
        mat-icon-button
        [ngClass]="{
          'rounded-full bg-blue-4 transition-colors duration-200': view() === 'text',
        }"
        aria-label="Show plain text"
        (click)="setView('text')"
      >
        <mat-icon>article</mat-icon>
      </button>

      <button
        mat-icon-button
        [ngClass]="{
          'rounded-full bg-blue-4 transition-colors duration-200': view() === 'html',
        }"
        aria-label="Show HTML view"
        (click)="setView('html')"
      >
        <mat-icon>code</mat-icon>
      </button>
    </div>
  </div>
  @if (view() === 'text') {
    <div [innerHTML]="textWithBreaks()"></div>
  } @else if (view() === 'html') {
    <aura-html-shadow [html]="email().html" [bypassSecurity]="true" />
  }
</div>
